<div *ngIf="isLoading" class="cssload-container">
  <div class="cssload-speeding-wheel"></div>
</div>
<ng-container *ngIf="projectInvoicesData$ | async as data">
  <div class="estimates">
    <div
      class="estimate"
      [ngClass]="{
        'is-in-payments': isInPayments,
        'is-approved': version.isApproved,
      }"
      *ngFor="let version of data.versioning?.versions"
    >
      <div class="checkmark">
        <img
          *ngIf="version.isApproved"
          src="/assets/confirm.svg"
          alt="Checkmark"
        />
        <img
          class="ready-for-approval"
          *ngIf="!version.isApproved && version.isAddedToApproved"
          src="/assets/confirm-gray.svg"
          alt="Checkmark"
        />
      </div>
      <div class="name">{{ version.name }}</div>
      <div class="amount estimate-item" *ngIf="isInPayments">
        {{ 'projectEstimate.estimatesAndInvoices.amount' | translate }}:
        <span
          >{{ projectBaseCurrency }}
          {{
            version.total *
              (1 + (feePercentage ? 1 / feePercentage : 0)) *
              (1 + (taxPercentage ? 1 / taxPercentage : 0)) | number
          }}</span
        >
      </div>
      <div class="send-date estimate-item" *ngIf="version.estimateSentDate">
        {{ 'projectEstimate.estimatesAndInvoices.dateOfSending' | translate }}:
        {{ version.estimateSentDate | date : 'dd.MM.yyyy' }}
      </div>
      <div
        class="sent-by estimate-item"
        *ngIf="isInPayments && version.estimateSentBy"
      >
        {{ 'projectEstimate.estimatesAndInvoices.sentBy' | translate }}:
        <span>{{ version.estimateSentBy }}</span>
      </div>
      <div class="approval-date estimate-item" *ngIf="version?.approvedDate">
        {{ 'projectEstimate.estimatesAndInvoices.dateOfApproval' | translate }}:
        {{ version?.approvedDate | date : 'dd.MM.yyyy' }}
      </div>
    </div>
  </div>
  <div class="switch-invoice-view">
    <div
      class="switch-invoice-view-btn"
      [class.selected]="!showingArchived"
      (click)="showArchived(false)"
    >
      {{ 'projectEstimate.estimatesAndInvoices.exportedInvoices' | translate }}
    </div>
    <div
      class="switch-invoice-view-btn"
      [class.selected]="showingArchived"
      (click)="showArchived(true)"
    >
      {{ 'projectEstimate.estimatesAndInvoices.archivedInvoices' | translate }}
    </div>
  </div>
  <div
    class="invoices"
    [ngClass]="{ 'is-in-payments': isInPayments }"
    [class.show-archived]="showingArchived"
  >
    <app-invoice
      [ngClass]="{ 'is-in-payments': isInPayments }"
      [class.archived]="invoice.isArchived"
      *ngFor="let invoice of data.invoices"
      [invoice]="invoice"
      [isInPayments]="isInPayments"
      (delete)="removeInvoice($event)"
    >
    </app-invoice>

    <app-invoice
      [ngClass]="{ 'is-in-payments': isInPayments }"
      [class.archived]="invoice.isArchived"
      *ngFor="let invoice of data.archivedInvoices"
      [invoice]="invoice"
      [isInPayments]="isInPayments"
      (delete)="removeInvoice($event)"
    >
    </app-invoice>
  </div>
</ng-container>
